export * from './localization.en';
export * from './localization.tc';
export * from './localization.sc';

export * from './keys.type';
